import { observable } from '@/libs/state'
import type { Notification, NotificationsPort } from './domain/notification'

const notifications$ = observable<Notification[]>([])

const notificationsAdapter: NotificationsPort = {
	push: notification => notifications$.push(notification),
	dismiss: id => notifications$.set(notifications$.get().filter(n => n.id !== id)),
	clear: () => notifications$.set([]),
	getAll: () => notifications$.get(),
	markRead: id =>
		notifications$.set(notifications$.get().map(n => (n.id === id ? { ...n, status: 'read' as const } : n))),
	markArchived: id =>
		notifications$.set(notifications$.get().map(n => (n.id === id ? { ...n, status: 'archived' as const } : n))),
	markAllRead: () =>
		notifications$.set(notifications$.get().map(n => (n.status === 'unread' ? { ...n, status: 'read' as const } : n))),
	archiveAll: () =>
		notifications$.set(
			notifications$.get().map(n => (n.status !== 'archived' ? { ...n, status: 'archived' as const } : n)),
		),
}

export { notifications$, notificationsAdapter }
